// extracted by mini-css-extract-plugin
export default {"container":"styles_container__lXx5b","row":"styles_row__1P1n4","maintitle":"styles_maintitle__siMLB","searchCol":"styles_searchCol__CYd1h","tet":"styles_tet__vY3dV"};